namespace Solovis.Reports.Parameters {

    export class TransactionParameterControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        public initialParameterValue;
        public currentTransaction;

        public selectedTransactionLabel;
        public selectTransactionLink;

        private _selectionDialog;


        constructor(options) {
            super(options);

            this._portalServices = options.portalServices;

            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;
            this.currentTransaction = this.initialParameterValue;
        }


        public static preload(newValue, callback, portalServices: Solovis.Portal.IPortalServices) {
            if (newValue && newValue.transactionId) {
                portalServices.rpc().invoke(
                    "~/Selectors/TransactionSelector/GetTransactionData", { transactionId: newValue.transactionId },
                    function (response, success) {
                        if (success) {
                            var transactionData = response.result;
                            callback(transactionData, true);
                        }
                        else {
                            callback(null, false);
                        }
                    });
            }
            else if (newValue && newValue.resourceId) {
                portalServices.rpc().invoke(
                    "~/Selectors/TransactionSelector/GetTransactionData", { resourceId: newValue.resourceId },
                    function (response, success) {
                        if (success) {
                            var transactionData = response.result;
                            callback(transactionData, true);
                        }
                        else {
                            callback(null, false);
                        }
                    });
            }
            else {
                callback(null, true);
            }
        };

        public static serializeParameterValue(value): any {
            if (value) {
                if (value.transactionId) {
                    return { transactionId: value.transactionId };
                }
                else if (value.resourceId) {
                    return { resourceId: value.resourceId };
                }
            }

            return null;
        }

        public static getLabel(value): string | undefined {
            return value?.label;
        }

        public doRender() {
            var self = this;

            this.selectedTransactionLabel = $("<a>").appendTo(this.container)
                .click(function (e) {
                    if (self.currentTransaction && self.currentTransaction.transactionId) {
                        Solovis.UI.PopupLinkPanel.showLinks({
                            offset: { left: e.pageX, top: e.pageY },
                            links: self._portalServices.reportLinker().getTransactionLinks(self.currentTransaction.transactionId)
                        });
                    }
                });
            this.selectTransactionLink = $("<a>").html("<span class='fa fa-pencil'></span>").appendTo(this.container);

            this.selectTransactionLink.click(function () {
                self._toggleSelectorDialog(function (transactionData) {
                    self._setCurrentTransactionData(transactionData);
                    self.notifyParameterValueChanged();
                });
            });

            // Set initial parameter value text.
            if (this.currentTransaction) {
                this._setCurrentTransactionData(this.currentTransaction);
            }
        }

        public _setCurrentTransactionData(transactionData) {
            this.currentTransaction = transactionData;
            if (this.currentTransaction) {
                this.selectedTransactionLabel.text(TransactionParameterControl.getLabel(this.currentTransaction) + " ");
            }
            else {
                this.selectedTransactionLabel.text("");
            }
        }

        public setParameterValue(newValue) {
            this._setCurrentTransactionData(newValue);
        }

        public getParameterValue() {
            if (this.state < Solovis.UI.BaseControl.ControlState.afterInit) {
                return this.initialParameterValue ? this.initialParameterValue : null;
            }
            else if (this.currentTransaction) {
                return Solovis.deepCopy(this.currentTransaction);
            }
            else {
                return null;
            }
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }


        public _toggleSelectorDialog(selectionCallback) {
            var self = this;

            if (this._selectionDialog) {
                // We already have the selection dialog open, so close it.
                this._selectionDialog.close();
                this._selectionDialog = null;
                return;
            }


            var selectorControlHostDiv = $("<div>");
            var selectorControlHost = new Solovis.UI.ControlHost({ container: selectorControlHostDiv });
            var selectorControl = new Solovis.InvDataSelectors.TransactionSelectorControl({
                controlHost: selectorControlHostDiv,
                portalServices: this._portalServices,
                selectionCallback: function (transaction) {
                    selectionCallback(transaction);

                    if (self._selectionDialog) {
                        self._selectionDialog.close();
                    }
                },
                cancelCallback: function () {
                    if (self._selectionDialog) {
                        self._selectionDialog.close();
                    }
                }
            });
            selectorControlHost.setCurrentControl(selectorControl);


            // Determine dialog position.        
            var linkOffset = $(this.selectedTransactionLabel).offset();
            var linkHeight = $(this.selectTransactionLink).outerHeight();
            var dialogPosition = {
                left: linkOffset.left,
                top: linkOffset.top + linkHeight + 5
            };

            var adjustedPosition = Solovis.UI.Dialog.autoAdjustSizeAndPosToViewport(dialogPosition, { width: 350, height: 150 });

            this._selectionDialog = new Solovis.UI.Dialog({
                container: selectorControlHostDiv,
                ownerDialog: Solovis.UI.Dialog.findContainingDialog(this.container),

                title: false,
                autoOpen: true,
                destroyOnClose: true,
                actions: ["Close"],
                noAnimation: true,
                position: adjustedPosition,

                buttons: [
                    {
                        label: "Clear",
                        click: function () {
                            selectionCallback(null);
                            self._selectionDialog.close();
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            self._selectionDialog.close();
                        }
                    }
                ],

                activate: function () {
                    selectorControl.focus();
                },

                deactivate: function () {
                    self._selectionDialog = null;
                }
            });
        }
    }

}
